let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ixdMf")).then(() => parcelRequire('5pT6s'));